var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_160_3626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4586 7.00988C30.3689 3.92014 26.2592 2.22229 21.8916 2.22229C17.518 2.22229 13.4143 3.92014 10.3246 7.00988C7.23486 10.0996 5.53101 14.2093 5.53101 18.5769C5.53101 27.4141 13.8883 34.7695 18.3819 38.7171C19.0058 39.2691 19.5398 39.743 19.9718 40.139C20.5117 40.643 21.2016 40.8949 21.8916 40.8949C22.5815 40.8949 23.2715 40.643 23.8054 40.139C24.2374 39.743 24.7773 39.2691 25.4013 38.7171C29.8889 34.7695 38.2462 27.4141 38.2462 18.5769C38.2462 14.2093 36.5483 10.0996 33.4586 7.00988V7.00988Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.137 25.7212V28.2222H26.331V19.8063C28.576 20.8296 30.137 23.0932 30.137 25.7212Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.531 25.7214C13.531 23.0932 15.0917 20.8295 17.3365 19.806V28.2219L13.531 28.222V25.7214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9912 19.3069C19.5242 20.3479 20.6067 21.0606 21.8561 21.0606C23.1029 21.0606 24.1841 20.3508 24.7181 19.3132C24.8489 19.3353 24.9786 19.3608 25.1067 19.3901V28.2221H18.5613V19.3906C18.7029 19.3578 18.8461 19.3306 18.991 19.307L18.9912 19.3069Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.747 12.2075H17.0784C17.2985 10.9607 17.9943 9.8781 18.9714 9.15421V12.2075H19.8193V8.6508C20.3167 8.4205 20.8607 8.27137 21.4324 8.22229V12.2071H22.2798L22.2796 8.22242C22.8513 8.27167 23.3943 8.42046 23.8923 8.65093V12.2073H24.7396V9.15399C25.7174 9.87784 26.4136 10.9604 26.6326 12.2073H26.9645C27.1986 12.2073 27.3886 12.397 27.3886 12.6308C27.3886 12.8651 27.1984 13.0548 26.9645 13.0548H16.7464C16.5118 13.0548 16.3228 12.8651 16.3228 12.6308C16.3233 12.3971 16.5129 12.2074 16.7471 12.2074L16.747 12.2075Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3928 13.7775C26.3928 16.2826 24.3612 18.3137 21.8562 18.3137C19.351 18.3137 17.3204 16.2827 17.3204 13.7775C17.3204 13.7563 17.3214 13.7355 17.3214 13.7145H26.3913C26.3913 13.7357 26.3931 13.7563 26.3931 13.7775H26.3928Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_160_3626",
    x: 0.0310059,
    y: 0.72229,
    width: 43.7151,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_160_3626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_160_3626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.f9dbab36bbd8184b3447a25761f11c73.svg";
export { ForwardRef as ReactComponent };